import React from 'react';
import {FormGroup, InputGroup} from '@blueprintjs/core';

interface CSVExportProps {
  filename?: string;
  delimiter?: string;
  onChange: (key: string) => (value: any) => void;
}

export const CSVExport = ({
  filename = '',
  delimiter = ',',
  onChange,
}: CSVExportProps) => {
  const onInputChange = (key: string) => (e: any) => {
    onChange(key)(e.target.value);
  }

  return (
    <>
      <FormGroup inline={true} label={'Filenam\uFEFFe'}>
        <InputGroup
          defaultValue={filename}
          autoComplete="off"
          onChange={onInputChange('filename')}
          placeholder="csv_file"
        />
      </FormGroup>
      <FormGroup inline={true} label="CSV Delimiter">
        <InputGroup
          defaultValue={delimiter}
          autoComplete="off"
          onChange={onInputChange('delimiter')}
        />
      </FormGroup>
    </>
  );
};

export default CSVExport;
